module.exports = __webpack_public_path__ + "media/images/visa_logo.svg-e02d2b35fc674a5131fc64424240c6bc.png";